module.exports = __webpack_public_path__ + "img/T2B_xh_5.6cab945d.png";